export default function siteContext(state = {}, {type}) {
    switch (type) {
        default:
            return state;
    }
}
